import React from "react";
import ITManifestStore from "data/dev/ITManifestStore";
import ITTestStore from "data/dev/ITTestStore";
import DevNavItems from "./DevNavItems";
import MocksetManifestStore from "data/dev/MocksetManifestStore";
import MocksetStore from "data/dev/MocksetStore";
import ITTestHistoryStore from "data/dev/ITTestHistoryStore";
import useFluxStore from "@armus/use-flux-store";

export default () => {
    const state = useFluxStore(() => ({
        mocksetLO: MocksetManifestStore.getLoadObject(),
        activeMockset: MocksetStore.getState().mockset,
        itTestLO: ITManifestStore.getLoadObject(),
        activeTest: ITTestStore.getState().path,
        history: ITTestHistoryStore.getState(),
    }), [
        MocksetManifestStore,
        MocksetStore,
        ITManifestStore,
        ITTestStore,
        ITTestHistoryStore,
    ]);
    return <DevNavItems {...state} />;
};



// WEBPACK FOOTER //
// ./app/views/dev/DevNavItemsContainer.js